// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input,select{border:1px solid #ccc}#form.squeeze{border:1px solid #fff;padding:20px;border-radius:5px;margin:0 0 60px;margin-bottom:30px!important;background:#fff;box-shadow:0 5px 40px -20px rgba(0,0,0,.45)}@media only screen and (min-width:768px){#form.squeeze{border:1px solid #fff;padding:20px;border-radius:5px;margin:10px 0;margin-bottom:10px!important;background:#fff;box-shadow:0 10px 80px -40px rgba(0,0,0,.45)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
